






























import { Component, Inject, Vue } from "vue-property-decorator";
import { ISuccess } from "../type";
import { copy } from "@/common/utils";
import { Toast } from "vant";
@Component
export default class Success extends Vue {
  @Inject()
  someValue!: ISuccess;

  get type() {
    return this.someValue.type === 1 ? "元" : "积分";
  }

  get status() {
    const array = ["可兑换", "已兑换", "已过期"];
    return array[this.someValue.codeStatus];
  }

  copy() {
    if (copy(this.someValue.code)) {
      Toast("复制成功");
      this.close(true);
    } else {
      Toast("复制失败");
    }
  }

  close(call: boolean) {
    this.$emit("close", call);
  }
}
